import moment from 'moment'
import identity from 'lodash/identity'
import { AIRDNA_TOOLIPS } from '../constants/messages'
import Format from '../Components/shared/Format'

const getMessageFormatter = intl => (key, amount) => {
  const message = AIRDNA_TOOLIPS[key]

  if (!message) {
    return ''
  }

  return intl.formatMessage(message, {
    amount: Format.number(amount)
  })
}

const mapForKey =
  (key, valueFormatter = identity) =>
  (intl, data, percentage = 1) => {
    const monthlyValues = data?.map(d => {
      return {
        month: d.date.split('-')[1], // month is the second element in the date string
        value: d[key]
      }
    })
    const messageFormatter = getMessageFormatter(intl)

    const datapoints = monthlyValues?.map(monthlyValue => {
      const m = moment()
        .startOf('day')
        .month(monthlyValue.month - 1)
        .date(1)
      const value = valueFormatter(monthlyValue.value * percentage)

      return {
        value,
        date: m.toDate(),
        tooltipEmphasis: messageFormatter(key, value),
        tooltipDescription: intl.formatMessage(AIRDNA_TOOLIPS.description, {
          month: m.format('MMM')
        })
      }
    })

    if (key !== 'occupancy') {
      return { datapoints, yFormat: 'money' }
    }

    return { datapoints }
  }

export const monthlyRevenue = mapForKey('revenue', Math.round)
export const monthlyOccupancy = mapForKey('occupancy', v => Math.round(30 * v))
export const nightlyRate = mapForKey('adr', Math.round)
